{
  "name": "LiveCo",
  "version": "1.24.8",
  "scripts": {
    "ng": "ng",
    "set-version": "git fetch --tags && node scripts/set-version.js",
    "set-version:staging": "git fetch --tags && node scripts/set-version.js --env staging",
    "set-version:prod": "git fetch --tags && node scripts/set-version.js --env prod",
    "start": "ng serve",
    "start:dev-staging": "ng serve --configuration dev-staging",
    "build": "ng build --base-href / --configuration development",
    "build:staging": "npm run set-version:staging && ng build --base-href / --configuration staging",
    "build:prod": "npm run set-version:prod && ng build --base-href / --configuration production",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "lint": "ng lint"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.2.4",
    "@angular/cdk": "22.2.5",
    "@angular/common": "22.2.4",
    "@angular/compiler": "22.2.4",
    "@angular/core": "22.2.4",
    "@angular/forms": "22.2.4",
    "@angular/material": "22.2.5",
    "@angular/platform-browser": "22.2.4",
    "@angular/router": "22.2.4",
    "@feathersjs/authentication": "^5.0.51",
    "@feathersjs/authentication-client": "^5.0.51",
    "@feathersjs/client": "^5.0.51",
    "@feathersjs/errors": "^5.0.50",
    "@feathersjs/feathers": "^5.0.50",
    "@feathersjs/rest-client": "^5.0.51",
    "@feathersjs/socketio-client": "^5.0.51",
    "@feathersjs/transport-commons": "^5.0.50",
    "@ngx-translate/core": "^18.1.0",
    "@rxweb/reactive-form-validators": "13.0.1",
    "@sentry/angular": "^11.10.0",
    "axios": "1.21.0",
    "date-fns": "^4.4.0",
    "jszip": "^3.10.2",
    "lodash-es": "^4.18.1",
    "marked": "^18.1.3",
    "mustache": "4.2.0",
    "ngx-cookie-service": "^22.0.0",
    "ngx-quill": "^31.0.1",
    "ngx-skeleton-loader": "^14.0.0",
    "quill": "^2.0.3",
    "rxjs": "~7.8.1",
    "sanitize-html": "^2.18.1",
    "socket.io-client": "^4.8.4",
    "tslib": "^2.9.1"
  },
  "devDependencies": {
    "@angular/build": "^22.2.5",
    "@angular/cli": "22.2.5",
    "@angular/compiler-cli": "22.2.4",
    "@eslint/js": "^10.0.1",
    "@types/lodash-es": "^4.17.12",
    "@types/node": "^26.6.6",
    "@types/quill": "^2.0.8",
    "@types/sanitize-html": "^2.16.2",
    "angular-eslint": "22.6.0",
    "autoprefixer": "^10.6.2",
    "eslint": "^10.14.0",
    "istanbul-lib-instrument": "^6.0.3",
    "jsdom": "^30.1.3",
    "moment": "^2.31.0",
    "postcss": "^8.5.32",
    "tailwindcss": "^3.4.17",
    "typescript": "~6.0.3",
    "typescript-eslint": "8.72.1",
    "vitest": "^5.1.0"
  }
}
